import { default as InboxSLAOnboardingModal } from '../../_internal/components/InboxSLAOnboardingModal';
export default InboxSLAOnboardingModal;